<template>
  <div class="">
      <!-- Site Name -->

      <br />
      <v-card>

        <v-card-title primary-title>
              <div>
                Your store is  <b>
                <a class="accent--text" :href="siteName"  target="_blank" >
                  {{siteName}}
                  <v-icon small class="ml-1">{{$vuetify.icons.openInNew}}</v-icon>
                </a></b>
                <br /><br />People can also email you using <b>{{siteEmail}}</b>.
                This will be automatically forwarded to your actual email address
                and any parents on your account.
              </div>
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat class="accent--text">
           Change Site Name
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

          </v-btn>
        </v-card-actions>

        <v-slide-y-transition>

          <v-card-text v-show="show">
            <v-form width="100px" v-model="valid">

              <v-layout align-center justify-center row fill-height>
                <span :class="nameClass">
                  {{ serverLoc }}
                </span>
                <v-text-field
                  v-model="newSiteName"
                  type="text"
                  :rules="nameRules"
                  required

                ></v-text-field>
              </v-layout>

                <v-layout row align-center justify-center>
                  <v-btn class="success" @click="submit"  :disabled="!valid" :loading="inprogress" >Change Site Name</v-btn>
                </v-layout>
            </v-form>
            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Site name was successfully updated.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../../utils.ts'
import config from '../../../config.js'

export default {
  name: 'SiteNameCard',
  components: {
  },
  computed: {
    ...mapState({
      siteName: state => {
        return config.serverLoc + state.admin.userInfo.aid
      },
      siteEmail: state => {
        return state.admin.userInfo.aid + '@' + config.emailDomain
      },
      locked: state => state.admin.public_settings.locked,
    }),
    'nameClass' : function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return ''
        case 'sm': return ''
        default: return 'title'
      }
    }
  },
  props: {

  },
  data () {
    return {
      serverLoc: config.serverLoc,
      show: false,
      valid: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null,
      newSiteName: '',
      nameRules: [
        utils.required('This field is required'),
        utils.minLength(3, 'Site name must be at least 3 characters long'),
        utils.maxLength(50, 'Site name cannot be more than 50 characters long'),
        utils.validChars(/^[a-z0-9-_]+$/, 'Site name can only have lowercase letters, numbers and underscores.')
      ]
    }
  },
  methods: {
    submit: async function () {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      try {
        if (this.locked) {
            throw new Error("Account is locked. You cannot make any changes.")
        }

        // Now link them and charge the account
        var updateSiteName = config.getFunctions().httpsCallable('updateSiteName')
        const rc = await updateSiteName(
          {
            newName: this.newSiteName
          }
        )
        console.log('RC from update:' + JSON.stringify(rc))

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        console.error('Could not change name: ' + JSON.stringify(err))
        this.errMessage = err.message
      }

      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
